import type { ImgHTMLAttributes } from "react";
import { cn } from "@shared/utils";

interface LogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** Which logo variant to use */
  variant?: "white" | "blue";
  /** Width in pixels */
  width?: number;
  /** Called when logo is clicked (optional) */
  onClick?: () => void;
}

/**
 * Logo atom.
 * Renders the TicketIn logo from public/svg folder.
 * Can be clickeable if onClick prop is provided.
 */
export function Logo({
  variant = "white",
  width = 200,
  className,
  onClick,
  ...props
}: LogoProps) {
  const src = variant === "blue" ? "/svg/logo_azul.svg" : "/svg/logo.svg";

  return (
    <img
      src={src}
      alt="TicketIn"
      className={cn(
        "h-auto object-contain",
        onClick && "cursor-pointer transition-opacity hover:opacity-80",
        className,
      )}
      style={{ width }}
      onClick={onClick}
      {...props}
    />
  );
}
